import React, { FunctionComponent, ReactNode } from 'react'

import { Box, BoxProps, Flex, smBumps, Typo, xsBumps, xxsBumps } from '../atoms'

export interface PremiumLineItem {
  header: ReactNode
  currentAmount: string
  previousAmount?: string
}

export interface PremiumBreakdownProps extends BoxProps {
  lineItems: PremiumLineItem[]
  additionalLineItems?: string[]
  ipt: ReactNode
  extraInfo?: ReactNode
}

export const PremiumBreakdown: FunctionComponent<PremiumBreakdownProps> = ({
  lineItems,
  additionalLineItems,
  ipt,
  extraInfo,
  ...props
}) => {
  return (
    <Box {...props}>
      {lineItems.map(({ header, previousAmount, currentAmount }, i) => (
        <Flex width={1} key={`premium-line-item-${i}`} my={smBumps}>
          <Typo typoSize='sm'>{header}</Typo>
          <Flex>
            {previousAmount && previousAmount !== currentAmount && (
              <Typo mr={xsBumps} color='inactive' typoSize='sm'>
                <s>{previousAmount}</s>
              </Typo>
            )}
            <Typo typoSize='sm'>{currentAmount}</Typo>
          </Flex>
        </Flex>
      ))}
      {extraInfo}
      {(additionalLineItems || ipt) && (
        <Flex
          flexDirection='column'
          width={1}
          borderTopWidth={1}
          py={smBumps}
          gap={xxsBumps}
        >
          {additionalLineItems?.map((it, i) => (
            <Box width={1} key={`additional-premium-line-item-${i}`}>
              <Typo typoSize='xs' color='bodySecondary'>
                {it}
              </Typo>
            </Box>
          ))}
          {ipt && (
            <Box width={1}>
              <Typo typoSize='xs' color='bodySecondary'>
                {ipt}
              </Typo>
            </Box>
          )}
        </Flex>
      )}
    </Box>
  )
}
